import { createContext } from 'react';

export const BleedContext = createContext({
  bleed: { left: 0, right: 0 },
});
